import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { ResourceLinks } from "../../../../constants";
import { makeArrayRandom } from "../../../../utils/learner";
import { useSelector } from "../../../../store";

export default function WebMultipleSelectText({ question, onAnswer = () => {} }) {
    const questionData = question;
    const learnerState = useSelector((state) => state.learner || {});
    const data = learnerState?.details?.testLevel === "vfh" ? questionData?.vfh : questionData?.acsf4;
    const imagesResources = ResourceLinks.llnQuizImage;

    const [info, setInfo] = useState(data.info);
    const [availableChoices, setAvailableChoices] = useState(
        makeArrayRandom(data.choices)
    );
    const [answer, setAnswer] = useState([]);

    // every time question change we will set to reset needed to reset
    useEffect(() => {
        setInfo(data.info);
        setAnswer([]);
        setAvailableChoices(makeArrayRandom(data.choices));
    }, [question,
        data.info,
        data.choices,
    ]);

    const handleChoiceClick = (choice) => {
        let ans = [...answer];
        if (ans.indexOf(choice.value) > -1) {
            removeChoice(choice.value);
        } else {
            if (!data.multiple && ans.length > 0) { // single if not exist set to empty
                setAnswer([]);
                ans = [];
            }

            ans = [...ans,
                choice.value,
            ];

            setAnswer(ans);
            checkCanProceed(ans);
        }
    }

    const checkCanProceed = (ans) => {
        const canProceed = ans.length > 0;
        const finalAnswer = data.multiple ? ans : (ans[0] ?? "");

        onAnswer({
            canProceed,
            answer: finalAnswer,
        });
    }

    const removeChoice = (value) => {
        let newAnswer = [...answer];
        let index = newAnswer.indexOf(value)
        if (index !== -1) {
            newAnswer.splice(index, 1);
            setAnswer(newAnswer);
        }
        checkCanProceed(newAnswer);
    }


    return (
        <Box
            sx={data.mainDivStyle}
        >
            <Box sx={data.infoStyle}>
                {info.map((row, index) => {
                    const Tag = row.type;
                    return (
                        <Tag key={index} style={row.style}>{typeof row.children != "undefined" ? 
                            row.children.map((childrenRow, rowChildrenIndex) => {
                                const ChildrenTag = childrenRow.type;
                                return (
                                    ChildrenTag === "img" 
                                    ? <ChildrenTag src={`${imagesResources}${childrenRow.value}`} style={childrenRow.style}/>
                                    : <ChildrenTag style={childrenRow.style}>{childrenRow.value}</ChildrenTag>
                                )
                            }): row.value}</Tag>
                    )
                })}
            </Box>
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "10px",
                textAlign: "center",
            }}>
                {availableChoices.map((choice, index) => (
                    <span key={index} 
                        style={{
                            marginBottom: "10px",
                            fontWeight: "normal",
                            display: "inline-table",
                            cursor: "pointer",
                            userSelect: "none",
                            backgroundColor: answer.includes(choice.value) ? "#afe23e" : "#dadada",
                            width: data.choicesStyle.width,
                            height: data.choicesStyle.height,
                            borderBottom: answer.includes(choice.value) ? "10px solid #639729" : "10px solid #808080",
                            textAlign: "center",
                            padding: "4px",
                            fontSize: "16.4px",
                        }}
                        onClick={() => handleChoiceClick(choice)}
                    >
                        <span style={{
                            display: "table-cell",
                            verticalAlign: "middle",
                            fontWeight: "normal",
                            cursor: "pointer",
                            textAlign: "center",
                        }}>{choice.value}</span>
                    </span>
                ))}
            </Box>
        </Box>
    );
};